export const getAllCategories = (edges) => {
    const availableCategories = {
        cats: [],
        dogs: []
    };

    (edges || []).forEach((post) => {
        // preparing all available categories
        const categories = post.node.frontmatter.categories || [];

        categories.forEach((c) => {
            // cats categories
            if (c.isCat) {
                if (!availableCategories.cats.find(category => category.value === c.value)) {
                    availableCategories.cats.push(c);
                }
            }
            // dogs categories
            if (c.isDog) {
                if (!availableCategories.dogs.find(category => category.value === c.value)) {
                    availableCategories.dogs.push(c);
                }
            }
        });
        // sort categories by priority
        availableCategories.cats.sort((a, b) => a.priority - b.priority);
        availableCategories.dogs.sort((a, b) => a.priority - b.priority);
    });

    return availableCategories;
}